import React from 'react';
import { branch, renderNothing, compose } from 'recompose';
import { PriceText, PriceWrapper } from './style';

const Price = ({ price, showPrices }) => (
  <PriceWrapper>
    <PriceText showPrices={showPrices}>
      {price.toFixed(2).replace('.', ',')} €
    </PriceText>
  </PriceWrapper>
);

export const PriceHider = ({ showPrices, children }) =>
  children({ showPrices });

const hideIfNoData = hasNoData => branch(hasNoData, renderNothing);
export default compose(hideIfNoData(props => !props.price))(Price);



// WEBPACK FOOTER //
// ../shop_main/components/price/index.js